import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Role} from '../../../../../core';

export const rolesAdapter: EntityAdapter<Role> = createEntityAdapter<Role>({
  selectId: model => model.rolId,
  sortComparer: (a: Role, b: Role): number =>
    b.rolId.localeCompare(a.rolId)
});

export interface RolesState extends EntityState<Role> {
  isLoading?: boolean;
  error?: string | null;
}

export const initialState: RolesState = rolesAdapter.getInitialState(
  {
    isLoading: false,
    error: null
  }
);
